import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
} from "@material-ui/core";
import { ReactComponent as SearchIcon } from "assets/icons/search-white.svg";
import { Pagination } from "@material-ui/lab";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import { SearchButton } from "components/searchButton";
import { Wrapper } from "components/wrapper";
import CustomBackdrop from "components/backdrop";
import MunicipalPortalAAppService from "application/platform/municipal-portal-service";
import { PaginationResponse } from "models/pagination-response";
import { IPlanoContratacaoAnualResponse } from "models/response/plano-contratacao-anual-response";

const formatDate = (value?: string | null) => value ? new Date(value).toLocaleDateString('pt-BR') : '-';

export function PlanosContratacaoAnualPage() {
  const [items, setItems] = useState(new PaginationResponse<IPlanoContratacaoAnualResponse>([], 0, 1, 10, 0));
  const [ano, setAno] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const load = async (page: number, anoFiltro?: string) => {
    try {
      setLoading(true);
      const result = await MunicipalPortalAAppService.listPlanosContratacaoAnual({
        page, pageSize: 10, ano: anoFiltro ? Number(anoFiltro) : undefined
      });
      setItems(result);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => { await load(0); })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageClick = (event: React.ChangeEvent<unknown>, value: number) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => { await load(value - 1, ano); })();
  };

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Plano de Contratações Anual" },
        ]}
      />
      <PageTitle>Plano de Contratações Anual</PageTitle>
      <Wrapper>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <TextField
                  variant="outlined"
                  fullWidth
                  type="number"
                  label="Ano"
                  value={ano}
                  onChange={(e) => setAno(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <SearchButton onClick={() => (async () => { await load(0, ano); })()}>
                  <SearchIcon /> Consultar
                </SearchButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <CustomBackdrop open={loading} />
            {items?.hasItems() ? (
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Ano</TableCell>
                      <TableCell>Data de Publicação</TableCell>
                      <TableCell align="center">Documento</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {items.items.map((item) => (
                      <TableRow key={item.id}>
                        <TableCell>{item.ano}</TableCell>
                        <TableCell>{formatDate(item.dtaPublicacao)}</TableCell>
                        <TableCell align="center">
                          <Button variant="contained" color="primary" size="small" href={item.documentoUrl} target="_blank" rel="noreferrer">
                            Abrir
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography variant="body1">Nenhum Plano de Contratações Anual encontrado.</Typography>
            )}
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={3} justifyContent="center">
              <Pagination
                size="large"
                variant="outlined"
                shape="rounded"
                onChange={handlePageClick}
                count={items?.pageCount}
                color="primary"
              />
            </Grid>
          </Grid>
        </Grid>
      </Wrapper>
    </>
  );
}
